import { Avatar, FormHelperText } from '@maas-components/core'
import styled from 'styled-components'

export const StyledAvatar = styled(Avatar)`
  && {
    background-color: ${({ color }) => color || '#B8DEFF'};
    color: ${({ theme, color }) => (color ? theme.palette.getContrastText(color) : '#0086FF')};
    width: ${({ theme }) => theme.spacing(2.25)}px;
    height: ${({ theme }) => theme.spacing(2.25)}px;
    font-size: ${({ theme }) => theme.typography.pxToRem(12)};
  }
`

export const StyledInputContainer = styled.div`
  & [class*='MuiInputLabel-outlined'] {
    transform: translate(24px, 15px) scale(1);
  }
`

export const StyledFormHelperText = styled(FormHelperText)`
  padding-left: ${({ theme }) => theme.spacing(3)}px;

  & svg {
    margin-right: ${({ theme }) => theme.spacing(0.5)}px;
    font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  }

  & span {
    font-weight: normal;
  }
`
